module.exports = __webpack_public_path__ + "static/media/org_parent.6587ee8d.svg";